import {Component, ElementRef, Input, OnInit, Output, EventEmitter, ViewChild} from '@angular/core';
import {TdoMdiResizeEvent} from '../events/tdo-mdi-resize.event';
import {NgxDrag, NgxResize, NgxResizeHandleType} from '@tdo-inc/ngx-drag-resize/dist/ngx-drag-resize';
import {TdoMdiBoundsModel} from '../models/tdo-mdi-bounds.model';

@Component({
  selector: 'tdo-mdi-item',
  templateUrl: './tdo-mdi-item.component.html',
  styleUrls: ['./tdo-mdi-item.component.scss']
})
export class TdoMdiItemComponent implements OnInit {
  @ViewChild('view') view: ElementRef;

  @Input() parentContainer: HTMLElement;
  @Input() width: number;
  @Input() height: number = 500;
  @Input() left: number;
  @Input() top: number;

  @Output() tdoMdiItemSelected = new EventEmitter<TdoMdiItemComponent>();
  @Output() tdoMdiItemResized = new EventEmitter<TdoMdiItemComponent>();
  zIndex = 0;

  readonly handleType = NgxResizeHandleType;

  originalBounds: TdoMdiBoundsModel;
  aspectRatio = 0

  originalWidth: number;
  originalHeight: number;
  originalLeft: number;
  originalTop: number;

  lastDragLeft: number = 0;
  isChangedByUser = false;

  isMaximized = false;

  private unmaximizedGeometry: TdoMdiBoundsModel = new TdoMdiBoundsModel();

  constructor(public elRef: ElementRef) { }

  ngOnInit(): void {
  }

  onResized(event: DOMRect): void {
    console.log('Event: ' + event);
  }

  onMdiResize(event: TdoMdiResizeEvent): void {
    console.log('onmdiresize: ' + event);
    this.width = event.width;
    this.height = event.height;
  }

  tdoMdiItemMouseDown(event: MouseEvent) {
    // event.cancelBubble = true;
    this.tdoMdiItemSelected.emit(this);
  }

  setOriginalBounds(bounds: TdoMdiBoundsModel, resetType = '') {
    if (!this.originalBounds) {
      this.originalBounds = bounds;
      if (bounds.width !== (bounds.height - 80)) {
        this.aspectRatio = (bounds.height / bounds.width) * 100;
      } else {
        this.aspectRatio = 100;
      }
    }

    console.log('Aspect ratio: ' + this.aspectRatio);

    if (this.isChangedByUser && resetType !== TdoMdiBoundsModel.HARD_RESET_TYPE) {
      return;
    }

    if (resetType === TdoMdiBoundsModel.HARD_RESET_TYPE) {
      this.isChangedByUser = false;
    }

    if ((!this.originalWidth || resetType !== '')) {
      this.originalWidth = bounds.width;
    }
    if ((!this.originalHeight || resetType !== '')) {
      this.originalHeight = bounds.height;
    }
    if ((!this.originalLeft || resetType !== '')) {
      this.originalLeft = bounds.left;
    }
    if ((!this.originalTop || resetType !== '')) {
      this.originalTop = bounds.top;
    }

    this.width = bounds.width;
    this.height = bounds.height;
    this.left = bounds.left;
    this.top = bounds.top;

    const parentBounds = this.parentContainer.getBoundingClientRect();
    if (this.originalWidth > parentBounds.width || this.originalHeight > parentBounds.height) {
      let ratio = 0;
      /*if (this.originalWidth > this.originalHeight) {

      }*/
      ratio = this.originalWidth / this.originalHeight;
      this.originalHeight = parentBounds.height - 100;
      this.originalWidth = this.originalHeight * ratio;
      this.width = parentBounds.width;
      this.height = parentBounds.height;
    }

    this.view.nativeElement.style.left = this.originalLeft + 'px';
    this.view.nativeElement.style.top = this.originalTop + 'px';
    this.view.nativeElement.style.width = this.originalWidth + 'px';
    this.view.nativeElement.style.height = this.originalHeight + 'px';

    this.tdoMdiItemResized.emit(this);
  }

  reset() {
    this.width = this.originalWidth;
    this.top = this.originalTop;
    this.left = this.originalLeft;
    this.view.nativeElement.style.left = this.originalLeft + 'px';
    this.view.nativeElement.style.top = this.originalTop + 'px';
    this.view.nativeElement.style.width = this.originalWidth + 'px';
    this.view.nativeElement.style.height = this.originalHeight + 'px';

    this.isChangedByUser = false;
  }

  tdoMdiItemMouseUp(event: MouseEvent) {
    this.isChangedByUser = true;
    //
  }

  onNgxResized(event: NgxResize) {
    console.log('Resized: ', event);
    //const bounds = this.elRef.nativeElement.getBoundingClientRect();

    this.tdoMdiItemResized.emit(this);

    setTimeout(() => {
      this.originalWidth = event.right - event.left;
      this.originalHeight = event.bottom - event.top;
    }, 100);

  }

  onHeaderDoubleClick(event: MouseEvent) {
    event.preventDefault();
    this.toggleMaximize();
  }
  toggleMaximize() {
    this.isMaximized = !this.isMaximized;
    if (this.isMaximized) {
      this.unmaximizedGeometry.width = this.originalWidth;
      this.unmaximizedGeometry.height = this.originalHeight;
      this.unmaximizedGeometry.top = this.originalTop;
      this.unmaximizedGeometry.left = this.originalLeft;

      const max = new TdoMdiBoundsModel();
      const parentBounds = this.parentContainer.getBoundingClientRect();
      max.left = 0;
      max.top = 0;
      max.width = parentBounds.width;
      max.height = parentBounds.height;
      max.height = (max.height * 0.75) - 20;
      max.width = (max.width * 0.5) - 20;
      this.setOriginalBounds(max, TdoMdiBoundsModel.HARD_RESET_TYPE);
    } else {
      this.setOriginalBounds(this.unmaximizedGeometry, TdoMdiBoundsModel.HARD_RESET_TYPE);
    }
  }

  toggleMaximizeKEEP() {
    this.isMaximized = !this.isMaximized;
    if (this.isMaximized) {
      this.unmaximizedGeometry.width = this.originalWidth;
      this.unmaximizedGeometry.height = this.originalHeight;
      this.unmaximizedGeometry.top = this.originalTop;
      this.unmaximizedGeometry.left = this.originalLeft;

      const max = new TdoMdiBoundsModel();
      const parentBounds = this.parentContainer.getBoundingClientRect();
      max.left = 0;
      max.top = 0;
      max.width = parentBounds.width;
      max.height = parentBounds.height;
      this.setOriginalBounds(max, TdoMdiBoundsModel.HARD_RESET_TYPE);
    } else {
      this.setOriginalBounds(this.unmaximizedGeometry, TdoMdiBoundsModel.HARD_RESET_TYPE);
    }
  }

  onNgxDragged(event: NgxDrag) {
    console.log('Dragged: ' + event);
    setTimeout(() => {
      this.originalLeft = event.left;
      this.originalTop = event.top - 90;
    }, 1);
  }
}
